module.exports = __webpack_public_path__ + "static/media/icons_Bilan pour ‚tudiants.949b46fd.svg";